import React from 'react';
import { Search, MoreVertical, Users, Building2, UserX } from 'lucide-react';
import { mockUsers } from '../../data/mockData';
export const UserManagement = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-904">
      <div data-id="element-905">
        <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-906">
          User Management
        </h1>
        <p className="text-slate-500 dark:text-slate-400" data-id="element-907">
          Manage buyers, sellers, and companies.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-908">
        {[{
        label: 'Total Users',
        value: '8,492',
        icon: Users,
        color: 'text-blue-600 dark:text-blue-400',
        bg: 'bg-blue-100 dark:bg-blue-400/10'
      }, {
        label: 'Companies',
        value: '450',
        icon: Building2,
        color: 'text-secondary',
        bg: 'bg-secondary/10'
      }, {
        label: 'Suspended',
        value: '24',
        icon: UserX,
        color: 'text-red-600 dark:text-red-400',
        bg: 'bg-red-100 dark:bg-red-400/10'
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-slate-200 dark:border-slate-700 flex items-center gap-4" data-id="element-909">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-910">
                <Icon size={24} data-id="element-911" />
              </div>
              <div data-id="element-912">
                <div className="text-2xl font-bold text-slate-900 dark:text-white" data-id="element-913">
                  {stat.value}
                </div>
                <div className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-914">
                  {stat.label}
                </div>
              </div>
            </div>;
      })}
      </div>

      <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden" data-id="element-915">
        <div className="p-4 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50" data-id="element-916">
          <div className="relative w-full max-w-md" data-id="element-917">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" size={16} data-id="element-918" />
            <input type="text" placeholder="Search users by name or email..." className="w-full pl-9 pr-4 py-2 rounded-lg bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white text-sm outline-none focus:ring-2 focus:ring-secondary" data-id="element-919" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-920">
          <table className="w-full text-left border-collapse" data-id="element-921">
            <thead data-id="element-922">
              <tr className="bg-slate-50 dark:bg-slate-900/50 text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700" data-id="element-923">
                <th className="p-4 pl-6" data-id="element-924">User</th>
                <th className="p-4" data-id="element-925">Type</th>
                <th className="p-4" data-id="element-926">Verification</th>
                <th className="p-4" data-id="element-927">Listings</th>
                <th className="p-4" data-id="element-928">Joined</th>
                <th className="p-4" data-id="element-929">Status</th>
                <th className="p-4 pr-6 text-right" data-id="element-930">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-700/50" data-id="element-931">
              {mockUsers.map(user => <tr key={user.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors" data-id="element-932">
                  <td className="p-4 pl-6 font-bold text-slate-900 dark:text-slate-200" data-id="element-933">
                    {user.name}
                  </td>
                  <td className="p-4 text-sm text-slate-600 dark:text-slate-300" data-id="element-934">
                    {user.type}
                  </td>
                  <td className="p-4" data-id="element-935">
                    <span className={`px-2 py-1 text-[10px] font-bold uppercase rounded ${user.verification === 'Verified' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400' : user.verification === 'Pending' ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400' : 'bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-400'}`} data-id="element-936">
                      {user.verification}
                    </span>
                  </td>
                  <td className="p-4 text-sm text-slate-600 dark:text-slate-300" data-id="element-937">
                    {user.listings}
                  </td>
                  <td className="p-4 text-sm text-slate-500 dark:text-slate-400" data-id="element-938">
                    {user.joined}
                  </td>
                  <td className="p-4" data-id="element-939">
                    <span className={`px-2 py-1 text-[10px] font-bold uppercase rounded ${user.status === 'Active' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400' : 'bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-400'}`} data-id="element-940">
                      {user.status}
                    </span>
                  </td>
                  <td className="p-4 pr-6 text-right" data-id="element-941">
                    <button className="p-2 text-slate-400 hover:text-slate-900 dark:hover:text-white rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors" data-id="element-942">
                      <MoreVertical size={18} data-id="element-943" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};